<template>
	<div class="imgEventDom" ref="imgEventDom">
		<div class="box">
			<div class="top_box">
				<div class="title-top">
					<img src="../../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.EventDetails }}</div>
				</div>
				<div class="hud-close-btn" @click="frontClose()">&times;</div>
			</div>

			<div class="eventAuto">
				<div style="width: 99%;display: flex;align-items: center;justify-content: space-around;">
					<!-- <video v-if="robotInfo.fileType == '1'" :src="robotInfo.eVideo" controls="controls" width="100%"></video> -->
					<div class="showRobotClass" v-if="ifZoom"
						:style="{zoom: robotInfo.imgList.length == 1 ? zoomNo : zoomNo*2, display: 'inline',width: robotInfo.imgList.length > 1 ? '75%' : '96%'}">
						<div class="showRotList showRotListOne" ref="showRotListRef">
							<img :src="checkInfo.imgUrl">
							<div class="errDiv" v-if="checkInfo.position" v-for="(obj, index) in checkInfo.position.split(';')"
								:style="{width: (Number(obj.split(',')[2])-Number(obj.split(',')[0]))-3 + 'px',height: (Number(obj.split(',')[3])-Number(obj.split(',')[1]))-3 + 'px',top: Number(obj.split(',')[1]) + 'px',left: Number(obj.split(',')[0]) + 'px'}">
							</div>
						</div>
					</div>
					<div v-else class="showRobotClass" :style="{borderRadius: '10px', width: robotInfo.imgList.length > 1 ? '75%' : '96%', height: '25vw'}">
						<div class="showRotList showRotListOne" ref="showRotListRef">
							<img :src="checkInfo.imgUrl">
						</div>
					</div>
					<div v-if="robotInfo.imgList.length > 1" class="changeTap" ref="changeTap">
						<div v-for="(obj,index) in robotInfo.imgList" :key="index" :style="{ border: (checkIndex == index) ? '2px solid #3f88ff' : 'none', borderRadius: '10px'}">
							<img :src="obj.imgUrl" @click="checkIndex=index;checkInfo = robotInfo.imgList[index]" :class=" index == checkIndex ? 'img_li' : 'img_li check_li' ">
						</div>
					</div>
				</div>

				<div class="eventInfo">
					<div class="eventInfo-title">{{ languageJson.EventInformation }} <span v-if="!robotInfo.isAddMisIdentification && robotInfo.misIdentificationType == '1'" style="color: #FF6A6A;cursor: pointer;" @click="changeWrong()">{{ languageJson.IncorrectIdentification }}</span></div>
					<div class="eventInfo-table">
						<div class="table-div">{{ languageJson.eventType }}</div>
						<div class="table-div">{{ languageJson.ReportingTime }}</div>
						<div class="table-div">{{ languageJson.robotName }}</div>
						<div class="table-div">{{ languageJson.Status }}</div>
						<div class="table-div" v-if="robotInfo.updDate">{{ languageJson.processingTime }}</div>
						<div class="table-div" v-if="robotInfo.handleName">{{ languageJson.ProcessedBy }}</div>
						<div class="table-div" v-if="tenantInfoId=='8cb99c581f2242479c964f7e569ff321'">{{ languageJson.address }}</div>
						<div class="table-div" v-if="((tenantInfoId!='8cb99c581f2242479c964f7e569ff321') && robotInfo.positionName)">{{ languageJson.clockInName}}</div>
						<div class="table-div" v-if="robotInfo.operationType == '8' && robotInfo.pm2_5">{{ languageJson.PM25 }} μg/m³</div>
						<div class="table-div" v-if="robotInfo.operationType == '14'">{{ languageJson.ExtinguishersNumber }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '32'">{{ languageJson.valveSwitch }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '33'">{{ languageJson.leakage }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '34'">{{ languageJson.lightBoxSwitch }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '31'">{{ languageJson.whatIsThis }}</div>
            <div class="table-div" v-if="robotInfo.instrumentStatus === '0'">{{ languageJson.result }}</div>
					</div>

					<div class="eventInfo-table tbody">
						<div class="table-div">{{ robotInfo.eName }}</div>
						<div class="table-div">{{ robotInfo.insDate }}</div>
						<div class="table-div">{{ robotInfo.rName }}</div>
						<div class="table-div">{{ robotInfo.resultsName }}</div>
						<div class="table-div" v-if="robotInfo.updDate">{{ robotInfo.updDate }}</div>
						<div class="table-div" v-if="robotInfo.handleName">{{ robotInfo.handleName}}</div>
						<div class="table-div" v-if="tenantInfoId=='8cb99c581f2242479c964f7e569ff321'">{{ robotInfo.instrument || '-' }}</div>
						<div class="table-div" v-if="((tenantInfoId!='8cb99c581f2242479c964f7e569ff321') && robotInfo.positionName)">{{ robotInfo.positionName }}</div>
						<div class="table-div" v-if="robotInfo.operationType == '8' && robotInfo.pm2_5">{{ robotInfo.pm2_5 }}</div>
						<div class="table-div" v-if="robotInfo.operationType == '14'">{{ robotInfo.fireExtinguisherResultNum }} / {{ robotInfo.fireExtinguisherNum }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '32'">{{ robotInfo.eventStatus == '0' ? '关' : '开'}}</div>
            <div class="table-div" v-if="robotInfo.operationType == '33'">{{ robotInfo.eventStatus == '0' ? '否' : '是' }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '34'">{{ robotInfo.eventStatus == '0' ? '关' : '开' }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '31' && robotInfo.eventStatus == '15'">{{ '猫咪' }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '31' && robotInfo.eventStatus == '16'">{{ '狗狗' }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '31' && robotInfo.eventStatus == '1'">{{ '自行车' }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '31' && robotInfo.eventStatus == '36'">{{ '滑板车' }}</div>
            <div class="table-div" v-if="robotInfo.operationType == '31' && robotInfo.eventStatus == '59'">{{ '床' }}</div>
            <div class="table-div" v-if="robotInfo.instrumentStatus === '0'">{{ robotInfo.instrument || '-' }}</div>
		</div>

					<div class="eventInfo-title" style="margin-top: 10px;" v-if="robotInfo.eType == 'E0300'">车辆信息：</div>
					<img :src="robotInfo.imgList[1].imgUrl" v-if="robotInfo.eType == 'E0300' && robotInfo.imgList.length > 1" style="width: 8vw;height: 3vw;marginBottom: 10px;" alt="">

					<div class="eventInfo-table" v-if="robotInfo.eType == 'E0300'">
						<div class="table-div">车牌号</div>
						<div class="table-div" style="background-color: #001127;">{{ robotInfo.carId ? robotInfo.carId : '一' }}</div>
						<div class="table-div">车位编号</div>
						<div class="table-div" style="background-color: #001127;">{{ robotInfo.carNum ? robotInfo.carNum : '一' }}</div>
					</div>

				</div>

				<div style="margin: 1%;" v-if="robotInfo.remark">
					<div class="remoke-title">{{ languageJson.Notes }}：{{ robotInfo.remark }}</div>
				</div>

				<div v-if="type != 'admin'">
					<div v-if="robotInfo.results != '1' && robotInfo.results != '3' && robotInfo.results != '5'">
						<div style="margin: 1%;">
							<div class="remoke-title">{{ languageJson.Notes }}</div>
							<el-input type="textarea" @focus="ruleForm.remark = ''" :rows="3" :placeholder="languageJson.pleaseEnterContent" maxlength="200" show-word-limit v-model="ruleForm.remark"></el-input>
						</div>
						<div style="display: flex;width: 100%;align-items: center;justify-content: center;padding-bottom: 1vw;">
							<div class="btn1" @click='doHandle()'>{{ languageJson.DetermineProcessing }}</div>
							<div class="btn1" @click='handleReport()'>{{ languageJson.ProcessAndReport }}</div>
						</div>
					</div>
				</div>
				<div v-else style="display: flex;width: 100%;align-items: center;justify-content: center;padding-bottom: 1vw;">
					<div class="btn1 btn2" @click='close()'>{{ languageJson.close }}</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import marquee from '@/components/marquee.vue'
	import {
		getItem
	} from '@/utils/auth'
	import {
		handleEvent,
		handleEventReport
	} from '@/api/admin'
	export default {
		name: '',
		data() {
			return {
				languageJson: languageJson,
				ruleForm: {
					remark: languageJson.Properlyhandled
				},
				tenantInfoId:getItem('tenantInfoId'),
				ifZoom: false,
				zoomNo: 0,
				checkInfo: {},
				checkIndex: 0,
				url: ""
			}
		},
		props: {
			robotInfo: null,
			type: String,
			clearWrong: Boolean
		},
		components: {
			marquee
		},
		mounted() {
		},
		methods: {
			changeWrong() {
				this.$emit('wrong',true)
			},
			frontClose() {
				if (this.type == 'admin') {
					this.close()
				} else {
					if (this.robotInfo.results == '5') {
						this.close()
					} else if ((this.robotInfo.results != '1' && this.robotInfo.results != '3') && this.robotInfo.priorityCode == 'HIGH') {
						this.$emit('frontClose', true)
					} else {
						this.close()
					}
				}
			},
			doHandle() {
				let that = this
				if (!that.ruleForm.remark) {
					that.$notify({
						title: languageJson.PleaseProcessing,
						type: 'warning'
					})
					return false
				} else {
					that.close()
					handleEvent({
						eventId: that.robotInfo.eventId,
						userId: getItem('userInfo').staffId,
						tenantInfoId: getItem('tenantInfoId'),
						remark: that.ruleForm.remark
					}).then(res => {
						that.$notify({
							title: languageJson.successful,
							type: 'success'
						})
						that.ruleForm.remark = ""
					})
				}
			},
			handleReport() {
				let that = this
				if (!that.ruleForm.remark) {
					that.$notify({
						title: languageJson.PleaseProcessing,
						type: 'warning'
					})
					return false
				} else {
					that.close()
					handleEventReport({
						eventId: that.robotInfo.eventId,
						eName: that.robotInfo.eName,
						number: that.robotInfo.number,
						userId: getItem('userInfo').staffId,
						staffName: getItem('userInfo').sName,
						tenantInfoId: getItem('tenantInfoId'),
						remark: that.ruleForm.remark
					}).then(res => {
						that.$notify({
							title: languageJson.successful,
							type: 'success'
						})
						that.ruleForm.remark = ""
					})
				}
			},
			close() {
				this.$emit('closeEventImage', true)
			}
		},
		watch: {
			robotInfo: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					that.checkIndex = 0
					that.ruleForm.remark = languageJson.Properlyhandled
					if (newValue.imgList.length == 1) {
						that.checkInfo = newValue.imgList[0]
						if (Number(newValue.imgList[0].width) > 0) {
							that.ifZoom = true
							that.$nextTick(function() {
								that.zoomNo = (that.$refs.imgEventDom.clientWidth * 0.96) / Number(newValue.imgList[0].width)
								that.$refs.showRotListRef.style.width = newValue.imgList[0].width + 'px'
								that.$refs.showRotListRef.style.height = newValue.imgList[0].height + 'px'
							})
						} else {
							that.ifZoom = false
							that.$nextTick(function() {
								that.$refs.showRotListRef.style.width = '100%'
								that.$refs.showRotListRef.style.height = '100%'
							})
						}
					} else if (newValue.imgList.length > 1) {
						that.ifZoom = false
						that.checkInfo = newValue.imgList[0]
						for (var i = 0; i < newValue.imgList.length; i++) {
							if (Number(newValue.imgList[i].width) > 0) {
								that.$nextTick(function() {
									that.ifZoom = true
									that.zoomNo = (that.$refs.imgEventDom.clientWidth * 0.96) / Number(newValue.imgList[i].width * 2)
									that.$refs.showRotListRef.style.width = newValue.imgList[i].width + 'px'
									that.$refs.showRotListRef.style.height = newValue.imgList[i].height + 'px'
								})
								return;
							} else {
								that.$nextTick(function() {
									that.$refs.showRotListRef.style.width = '100%'
									that.$refs.showRotListRef.style.height = '100%'
								})
							}
						}
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@opacity: 0.7;
	@opBackgroundColor: #1A3048;

	.hideEventDom {
		border-radius: 0;
	}
	.imgEventDom /deep/.el-textarea__inner {
		color: #b0d8ff;
		background-color: rgba(0, 15, 50, 0.6);
		border: 1px solid rgba(0, 180, 255, 0.25);
	}

	.imgEventDom /deep/ .el-form-item {
		margin-bottom: 0px;
	}

	.imgEventDom /deep/.el-form-item__label {
		color: white;
		font-size: 0.7vw;
		line-height: 25px;
	}

	.imgEventDom /deep/ .el-textarea__inner {
		font-size: 0.7vw;
	}

	.eventAuto {
		position: absolute;
		width: 100%;
		height: 34vw;
		overflow-y: auto;
		overflow-x: hidden;
	}

	::-webkit-scrollbar-track {
		border-radius: 10px;
		background-color: rgba(0, 20, 60, 0.5);
	}

	/*定义滑块 内阴影+圆角*/
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 180, 255, 0.2);
		background-color: rgba(0, 100, 180, 0.4);
		cursor: pointer;
	}

	.remoke-title {
		text-align: left;
		margin: .2vw 0;
		color: #9CC3FF;
		font-size: .7vw;
	}

	.eventInfo {
		margin: 1vw 0 .4vw .4vw;
		color: #b0d8ff;
		font-size: .7vw;
		&-title {
			text-align: left;
			margin-bottom: .2vw;
		}
		&-table {
			width: 99%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: rgba(0, 40, 90, 0.5);
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-right: none;
		}

		.tbody {
			background-color: transparent;
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-top: none;
			border-right: none;
		}

		.table-div {
			padding: 0.3vw 0;
			border-right: 1px solid rgba(0, 180, 255, 0.25);
			text-align: center;
			width: 30%;
		}
	}

	.title-top {
		display: flex;
		color: #fff;
		font-size: 1vw;
		align-items: center;
		justify-content: flex-start;
		&-text {
			text-shadow: 0px 2px 4px rgba(0,29,95,0.5);
			background: linear-gradient(180deg, #FFFFFF 0%, #9FE3FF 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-weight: bold;
			color: #FFFFFF;
		}

		img {
			width: 1vw;
			margin-right: 0.3vw;
		}
	}

	.img_li {
		width: 100%;
		height: 100%;
		border-radius: 10px;
		cursor: pointer;
	}

	.check_li {
		filter: contrast(20%);
	}

	.changeTap {
		width: 16%;
		height: 25vw;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;

		div {
			margin-bottom: 1.5vw;
		}
	}

	.showRobotClass {
		margin: 0 auto;
		// height: 20vw;
		font-size: 0;
		position: relative;

		.showRotList {
			width: 50%;
			height: 50%;
			display: inline-block;
			position: relative;
			color: white;
			font-size: 12px;

			img {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				border-radius: 10px;
			}

			div {
				padding: 3px 20px;
				background-color: @opBackgroundColor;
				opacity: @opacity;
			}

			.errDiv {
				border: 2px solid #ffd400;
				position: absolute;
				background-color: transparent;
				padding: 0;
			}

			.title {
				position: absolute;
				top: 0;
				left: 0;
				border-radius: 0 0 10px 0;
			}

			.time {
				position: absolute;
				bottom: 0;
				left: 0;
				border-radius: 0 10px 0 0;
			}
		}

		.showRotListOne {
			width: 100%;
			height: 100%;
		}
	}

	.box {
		width: 100%;
		height: 38vw;
		background: linear-gradient(145deg, rgba(0, 15, 50, 0.98), rgba(0, 8, 30, 0.99));
		border: 1px solid rgba(0, 240, 255, 0.2);
		border-radius: 8px;
		overflow: hidden;
		position: relative;

		&::before {
			content: '';
			position: absolute;
			top: 0; left: 0; right: 0;
			height: 2px;
			background: linear-gradient(90deg, transparent, rgba(0, 240, 255, 0.6), rgba(0, 128, 255, 0.4), transparent);
			z-index: 2;
		}

		.top_box {
			display: flex;
			justify-content: space-between;
			margin: 12px;
			padding-top: 0.4vw;
			color: #fff;
			font-size: 0.8vw;
			.title-top {
				display: flex;
				color: #fff;
				font-size: 1vw;
				align-items: center;
				justify-content: flex-start;
				&-text {
					color: #e0f0ff;
					font-size: 0.8vw;
					font-weight: 600;
					text-shadow: 0 0 8px rgba(0, 240, 255, 0.4);
				}

				img {
					width: 0.7vw;
					margin-right: 0.3vw;
					filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.5));
				}
			}
		}
	}

	.hud-close-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 1.5vw;
		height: 1.5vw;
		cursor: pointer;
		color: rgba(0, 240, 255, 0.6);
		font-size: 1.2vw;
		line-height: 1;
		border: 1px solid rgba(0, 240, 255, 0.2);
		border-radius: 4px;
		background: rgba(0, 15, 50, 0.6);
		transition: all 0.3s ease;
		margin-top: 0.2vw;

		&:hover {
			color: #00f0ff;
			border-color: rgba(0, 240, 255, 0.5);
			background: rgba(0, 40, 90, 0.8);
			box-shadow: 0 0 10px rgba(0, 240, 255, 0.3);
		}
	}

	.hideboxDom {
		background: none;
	}

	.baceName {
		width: 100%;
		display: flex;
		align-items: center;
		margin: 2% 1%;
		// justify-content: space-between;
		flex-wrap: wrap;
		font-size: 0.7vw;
		color: white;

		.divText {
			width: 18%;
			padding-left: 1vw;
		}
	}

	.btn1 {
		width: 10vw;
		padding: 0.4vw 0;
		margin-right: 16px;
		font-size: 0.7vw;
		font-weight: 700;
		text-align: center;
		cursor: pointer;
		color: #b0d8ff;
		background: linear-gradient(180deg, rgba(0, 60, 120, 0.6), rgba(0, 30, 80, 0.8));
		border: 1px solid rgba(0, 180, 255, 0.3);
		border-radius: 4px;
		transition: all 0.3s ease;

		&:hover {
			background: linear-gradient(180deg, rgba(0, 100, 200, 0.7), rgba(0, 50, 120, 0.9));
			border-color: rgba(0, 240, 255, 0.5);
			color: #e0f0ff;
			box-shadow: 0 0 12px rgba(0, 240, 255, 0.2);
		}
	}

	.btn2 {
		margin-right: 0;
	}

</style>



// WEBPACK FOOTER //
// src/page/robotDetail/components/eventImgUser.vue